import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { withCookies } from "react-cookie";

import queryString from "query-string";
import ScheduleList from "./_list";
import Select from "react-select";
import DateRange from "../../Components/DateRange";
import { encodeBody } from "../../BackendClient";
import ApiClient from "../../Client";
import DateFormat from "../../helpers/DateFormat";
import { extendStyles } from "../../helpers/formComponent"

const mapStateToProps = ({ identity }) => ({
  identity
});

class Schedule extends Component {
  state = {
    cities: null,
    theatres: null,
    sort: ["film.title", true],
    filters: {}
  };

  componentDidUpdate() {
    const { city, theatre, dateBegin, dateEnd } = queryString.parse(
      this.props.location.search,
      {
        decode: true,
        arrayFormat: "none"
      }
    );

    let { filters: stateFilters, theatres } = this.state;
    const parsedFilters = {};
    if (city) {
      stateFilters.city !== city && Object.assign(parsedFilters, { city });
    } else if (stateFilters.city) {
      Object.assign(parsedFilters, { city: null });
    }

    if (theatre) {
      stateFilters.theatre !== theatre &&
        Object.assign(parsedFilters, { theatre });
    } else if (stateFilters.theatre) {
      Object.assign(parsedFilters, { theatre: null });
    }

    if (dateBegin) {
      if (
        !stateFilters.dateBegin ||
        DateFormat.ddmmyyyy(stateFilters.dateBegin) !== dateBegin
      ) {
        const dtBegin = this.strToDate(dateBegin);
        dtBegin && Object.assign(parsedFilters, { dateBegin: dtBegin });
      }
    } else if (stateFilters.dateBegin) {
      Object.assign(parsedFilters, { dateBegin: null });
    }
    if (dateEnd) {
      if (
        !stateFilters.dateEnd ||
        DateFormat.ddmmyyyy(stateFilters.dateEnd) !== dateEnd
      ) {
        const dtEnd = this.strToDate(dateEnd);
        dtEnd && Object.assign(parsedFilters, { dateEnd: dtEnd });
      }
    } else if (stateFilters.dateEnd) {
      Object.assign(parsedFilters, { dateEnd: null });
    }

    const hasNewFilters = !!Object.entries(parsedFilters).length;
    const filters = hasNewFilters
      ? Object.assign(stateFilters, parsedFilters)
      : stateFilters;

    if (city && !(stateFilters.city === city && theatres)) {
      this.fetchTheatres({ city: { id: city } }).then(theatres =>
        this.setState({ theatres, filters })
      );
    } else if (hasNewFilters) {
      this.setState({ filters });
    }
  }

  getAuthCookie() {
    const { cookies } = this.props;
    return cookies.get(process.env.REACT_APP_IDENTITY_COOKIE) || "";
  }

  fetchTheatres(where) {
    const authKey = this.getAuthCookie();
    return ApiClient.setHeader("authKey", authKey)
      .request(
        `query($where:TheatreWhereInput!){
          theatres(where:$where){id name value:id label:name}
        }`,
        { where }
      )
      .then(({ theatres }) => theatres);
  }

  fetchCities() {
    const authKey = this.getAuthCookie();
    return ApiClient.setHeader("authKey", authKey)
      .request(`{cities{id name value:id label:name}}`)
      .then(({ cities }) => cities);
  }

  findTheatreCity(id) {
    const authKey = this.getAuthCookie();
    return ApiClient.setHeader("authKey", authKey)
      .request(
        `query($id:ID!){
          theatre(where:{id:$id}){id city{id}}
        }`,
        { id }
      )
      .then(({ theatre }) => theatre);
  }

  componentDidMount() {
    const { city, theatre, dateBegin, dateEnd } = queryString.parse(
      this.props.location.search,
      {
        decode: true,
        arrayFormat: "none"
      }
    );
    const {
      cities,
      filters: { theatreFilter }
    } = this.state;

    if (cities === null) {
      this.fetchCities().then(cities => this.setState({ cities }));
    }
    if (theatre && !(city && theatreFilter)) {
      this.findTheatreCity(theatre)
        .then(row =>
          Object.assign(
            { dateBegin, dateEnd },
            row && row.city ? { city: row.city.id, theatre } : { theatre: null }
          )
        )
        .then(params => this.updateLink(params));
    }
  }

  strToDate = str => {
    let pattern = /(\d{2})\.(\d{2})\.(\d{4})/;
    return new Date(str.replace(pattern, "$3-$2-$1"));
  };

  dateRangeFilterOnChange = ({ startDate, endDate }) => {
    this.updateLink({
      dateBegin: DateFormat.ddmmyyyy(startDate),
      dateEnd: DateFormat.ddmmyyyy(endDate)
    });
  };

  cityFilterOnChange = city => {
    this.updateLink({ city: (city && city.value) || null, theatre: null });
    this.setState({ theatres: null });
  };

  theatreFilterOnChange = theatre => {
    this.updateLink({ theatre: (theatre && theatre.value) || null });
  };

  updateLink(newParams) {
    const {
      filters: { dateBegin, dateEnd, ...stateFitlers }
    } = this.state;
    const filters = Object.assign({}, stateFitlers);
    const params = Object.assign(filters, newParams);
    if (!params.dateBegin && dateBegin) {
      Object.assign(params, { dateBegin: DateFormat.ddmmyyyy(dateBegin) });
    }
    if (!params.dateEnd && dateEnd) {
      Object.assign(params, { dateEnd: DateFormat.ddmmyyyy(dateEnd) });
    }
    const body = Object.entries(params).reduce(
      (prev, [key, value]) =>
        (value && Object.assign(prev, { [key]: value })) || prev,
      {}
    );
    const stringParams = encodeBody(body);
    this.props.history.push(`schedule${stringParams && "?" + stringParams}`);
  }

  getRange() {
    let {
      filters: { dateBegin, dateEnd }
    } = this.state;
    if (dateBegin && dateEnd) {
      return { dateBegin, dateEnd };
    }
    return {
      dateBegin: new Date(2018, 4, 1),
      dateEnd: new Date(2018, 4, 7)
    };
  }

  getDates() {
    const { dateBegin, dateEnd } = this.getRange();
    const range = [];
    range.push(dateBegin.getTime());
    range.push(dateEnd.getTime());
    return range;
  }

  findOptionByValue(list, value) {
    if (list && value) {
      for (let idx = 0; idx < list.length; idx++) {
        if (list[idx].value === value) {
          return list[idx];
        }
      }
    }
    return null;
  }

  // pickerFocusChange = focusedInput => {
  //   if (this.state.focusedInput !== focusedInput) {
  //     this.setState({ focusedInput });
  //   }
  // };

  // pickerDatesChange = ({ startDate, endDate }) => {
  //   if (startDate && endDate) {
  //     this.updateLink({
  //       dateBegin: DateFormat.ddmmyyyy(startDate.toDate()),
  //       dateEnd: DateFormat.ddmmyyyy(endDate.toDate())
  //     });
  //   }
  // };

  renderFilters() {
    const {
      cities,
      theatres,
      filters
      // focusedInput,
      // filters: { dateBegin, dateEnd }
    } = this.state;
    const dates = this.getDates();

    // {console.log(dates)}
    // const maximumDays = 31;
    // const startDate = moment(dateBegin.getTime());
    // const endDate = moment(dateEnd.getTime());
    // const isOutsideRange = day =>
    //   focusedInput === END_DATE &&
    //   (day.isBefore(startDate, "day") ||
    //     day.isAfter(startDate.clone().add(maximumDays, "days"), "day"));
    return (
      <div className="filterSchedules">
        <div className="office-filters">
          <div className="office-filters__half custom-datepicker__group">
            <label
              htmlFor="session-datepicker"
              className="custom-datepicker__label"
            >
              День начала/окончания
            </label>
            {
              //   <DateRangePicker
              //   readOnly
              //   noBorder
              //   block
              //   hideKeyboardShortcutsPanel
              //   keepOpenOnDateSelect
              //   isOutsideRange={isOutsideRange}
              //   // disabled={false}
              //   // appendToBody={false}
              //   // firstDayOfWeek={4}
              //   // minimumNights={21}
              //   displayFormat="MMMM Do YYYY"
              //   startDateId={START_DATE}
              //   endDateId={END_DATE}
              //   startDate={startDate}
              //   endDate={endDate}
              //   // orientation={VERTICAL_ORIENTATION}
              //   focusedInput={focusedInput}
              //   onFocusChange={this.pickerFocusChange}
              //   onDatesChange={this.pickerDatesChange}
              // />
            }
            {
              <DateRange
                input
                dateBegin={(dates[0] && new Date(dates[0])) || null}
                dateEnd={(dates[1] && new Date(dates[1])) || null}
                onChange={this.dateRangeFilterOnChange}
                className="custom-datepicker__input"
              />
            }
            {
              <img
                src="/images/icon-calendar.png"
                alt=""
                className="custom-datepicker__icon"
              />
            }
          </div>
          <div style={{ display: "contents" }}>
            <div className="office-filters__half custom-select__group">
              <Select
                onChange={this.cityFilterOnChange}
                options={cities || []}
                value={this.findOptionByValue(cities, filters.city)}
                className="selectReact"
                classNamePrefix="selectReact"
                isClearable
                placeholder="Начните вводить название города"
                styles={extendStyles()}
              />
            </div>
            <div className="office-filters__full">
              <Select
                onChange={this.theatreFilterOnChange}
                options={theatres || []}
                value={this.findOptionByValue(theatres, filters.theatre)}
                className="selectReact"
                classNamePrefix="selectReact"
                isDisabled={!filters.city}
                isClearable
                placeholder="Начните вводить название кинотеатра"
                styles={extendStyles()}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      filters: { theatre }
    } = this.state;
    const { dateBegin, dateEnd } = this.getRange();
    let content = "";
    if (dateBegin && dateEnd && theatre) {
      content = (
        <ScheduleList
          dateBegin={dateBegin}
          dateEnd={dateEnd}
          theatreId={theatre}
          canBeDelete
        />
      );
    }
    return (
      <Fragment>
        <h1 className="office-h1">Загрузка расписания</h1>
        <div className="office__schedule-upload">
          <Link to="/schedule/create" className="btn-gradient">
            Добавить сеанс
          </Link>
          {this.renderFilters()}
          {content}
        </div>
      </Fragment>
    );
  }
}
export default withCookies(withRouter(connect(mapStateToProps)(Schedule)));



// WEBPACK FOOTER //
// ./src/containers/schedule/admin.jsx